import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45f15c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" mdi-cloud-upload ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ma-0 text-caption" }, " ここにファイルをドラッグ&ドロップ ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ma-0 text-caption" }, " またはクリックしてファイルを選択してください ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ma-0 text-caption" }, " (.stl, .obj形式に対応しています) ", -1))
const _hoisted_5 = { class: "ml-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("mdi-close-circle")
const _hoisted_7 = {
  class: "pa-4",
  style: {"background":"white"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" mdi-upload ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("読み込む ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" mdi-close ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("キャンセル ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.dialog,
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("input", {
        id: "file",
        ref: "fileInput",
        accept: ".stl,.obj",
        type: "file",
        style: {"display":"none"},
        multiple: "",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
      }, null, 544),
      _createVNode(_component_v_card, {
        link: "",
        elevation: "0",
        class: "rounded-0 px-10",
        onClick: _ctx.onSelect,
        onDrop: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onDrop($event)), ["prevent"])),
        onDragover: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.state.dragOver = true), ["prevent","stop"])),
        onDragenter: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.state.dragOver = true), ["prevent","stop"])),
        onDragleave: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.state.dragOver = false), ["prevent","stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "d-flex flex-column mb-4",
                dense: "",
                align: "center",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: _normalizeClass(["transition", [_ctx.state.dragOver ? 'mt-2, mb-6' : 'mt-5']]),
                    size: "60"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4
                ]),
                _: 1
              }),
              (_ctx.state.files.length > 0)
                ? (_openBlock(), _createBlock(_component_v_list, {
                    key: 0,
                    height: "150",
                    "item-height": "50",
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.files, (item) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: item.name
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "mr-2 text-caption" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                _createElementVNode("span", _hoisted_5, _toDisplayString(item.size) + " bytes", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_list_item_action, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  icon: "",
                                  onClick: _withModifiers(($event: any) => (_ctx.removeFile(item.name)), ["stop"]),
                                  elevation: "0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        _hoisted_6
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_btn, {
          color: "primary",
          class: "mb-2",
          block: "",
          disabled: _ctx.state.files.length <= 0,
          onClick: _withModifiers(_ctx.submit, ["stop"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "small",
              class: "mr-1"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _hoisted_9
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_v_btn, {
          block: "",
          disabled: _ctx.state.files.length <= 0,
          onClick: _withModifiers(_ctx.close, ["stop"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "small",
              class: "mr-1"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}